/**
 * Dominios de correo personal que NO se aceptan para registrar una empresa.
 * Se usa tanto en el formulario como en la edge function `register-enterprise`.
 */
export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.es',
  'hotmail.co.uk',
  'outlook.com',
  'outlook.es',
  'live.com',
  'live.com.mx',
  'msn.com',
  'yahoo.com',
  'yahoo.es',
  'yahoo.com.mx',
  'ymail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'pm.me',
  'gmx.com',
  'gmx.es',
  'zoho.com',
  'mail.com',
  'yandex.com',
  'tutanota.com',
  'hotmail.com.co',
  'outlook.com.co',
];

export function getEmailDomain(email: string): string {
  return (email || '').trim().toLowerCase().split('@')[1] ?? '';
}

export function isPersonalEmail(email: string): boolean {
  return PERSONAL_EMAIL_DOMAINS.includes(getEmailDomain(email));
}

export const CORPORATE_EMAIL_MESSAGE =
  'Usa el correo de tu empresa. No aceptamos correos personales como Gmail, Hotmail u Outlook.';
